export const packageVersion = '11.1.0';
